define(
    'viewmodels/secured/explorer/context',[
        "providers/dataprovider"
    ],
    function (dataProvider) {
        //"services/storage",
        //storage.storage = sessionStorage;

        var context = {
            current: {
                library: null,
                list: null,
                listValue: null,
                folder: null,
                document: null
            },

            menu: null,

            states: new Array(),

            loadFoldersForLibrary: loadFoldersForLibrary,
            loadFoldersForListValue: loadFoldersForListValue,
            loadListValueForLibrary: loadListValueForLibrary,

            loadState: loadState,
            saveState: saveState,

            //loadStateSession: loadStateSession,

            pendingRefresh: [],

            findFolder: findFolder,
            removeFolder: removeFolder,

            onNavSearch: ko.observable().extend({ notify: 'always' }),
            onNavFavoriteDocument: ko.observable().extend({ notify: 'always' }),
            onNavFavoriteFolder: ko.observable().extend({ notify: 'always' }),
            onNavFavoriteSearch: ko.observable().extend({ notify: 'always' }),
            onNavFlagged: ko.observable().extend({ notify: 'always' }),
            onNavRecent: ko.observable().extend({ notify: 'always' }),
            onNavAllCheckedOut: ko.observable().extend({ notify: 'always' }),
            onNavMyCheckedOut: ko.observable().extend({ notify: 'always' }),
            onNavFolder: ko.observable().extend({ notify: 'always' }),
            onNavFolderShowDeleted: ko.observable().extend({ notify: 'always' }),
            onNavFolderShowAll: ko.observable().extend({ notify: 'always' }),
            onNavMyDeleted: ko.observable().extend({ notify: 'always' }),
            onNavAllDeleted: ko.observable().extend({ notify: 'always' }),

            onDocument: ko.observable().extend({ notify: 'always' }),
            onReloadFolders: ko.observable().extend({ notify: 'always' }),
            onReloadResults: ko.observable().extend({ notify: 'always' }),
            onDocumentChecked: ko.observable().extend({ notify: 'always' }),
            onDocumentFavorited: ko.observable().extend({ notify: 'always' }),
            onDocumentFlagged: ko.observable().extend({ notify: 'always' }),
            onListValueFilter: ko.observable().extend({ notify: 'always' }),

            //documentsUpdateQ: [],
            //addDocumentsUpdateQ: addDocumentsUpdateQ,
            //removeDocumentsUpdateQ: removeDocumentsUpdateQ
        };

        function resetCurrent() {
            context.current = Object.create({
                library: null,
                list: null,
                listValue: null,
                folder: null,
                document: null
            });
        }

        function loadState(libraryId) {
            var newobj = Object.create({
                library: null,
                list: null,
                listValue: null,
                folder: null,
                document: null
            });

            if (libraryId == null)
                return newobj;

            //context.states = storage.getObject("ctxstatestate") || [];
            //context.current = storage.getObject("ctxstatecurrent") || newobj;

            var state = context.states[libraryId];

            if (state === undefined) {
                return Object.create({
                    library: null,
                    list: null,
                    listValue: null,
                    folder: null,
                    document: null
                });
            }

            return {
                library: state.library,
                list: state.list,
                listValue: state.listValue,
                folder: state.folder,
                document: state.document
            };
        }
        function saveState(libraryId, state) {
            context.states[libraryId] = {
                library: state.library,
                list: state.list,
                listValue: state.listValue,
                folder: state.folder,
                document: state.document
            };

            //storage.setObject("ctxstatestate", context.states);
            //storage.setObject("ctxstatecurrent", context.current);
        }

        //function loadStateSession() {
        //    var newobj = Object.create({
        //        library: null,
        //        list: null,
        //        listValue: null,
        //        folder: null,
        //        document: null
        //    });

        //    context.states = storage.getObject("ctxstatestate") || [];
        //    context.current = storage.getObject("ctxstatecurrent") || newobj;
        //}

        function findFolder(f) {
            var folderId = f.folderId;
            var libraryId = f.libraryId;
            var state = context.states[libraryId];

            if (state && state.library) {
                var f = null;

                if (!f) {
                    f = _findFolder(state.library.folders(), folderId);
                }

                if (!f && state.library.hasList()) {
                    f = _findFolder(state.library.list.folders(), folderId);
                }

                return f;
            }

            return null;
        }
        function removeFolder(f) {
            var folderId = f.folderId;
            var libraryId = f.libraryId;
            var parentId = f.parentId;

            var parent = findFolder({ folderId: parentId, libraryId: libraryId });

            if (parent) {
                var f2 = null;

                if (!f2 && parent.folders !== undefined) {
                    var fs = _.reject(parent.folders, function (itm) { return itm.folderId == folderId; });
                    parent.folders = fs;
                }
            }
        }

        function loadFoldersForLibrary(library) {
            var d = $.Deferred();

            dataProvider
            .folders
            .getLibraryFolders(library.libraryId)
            .done(function (folders) {
                d.resolve(folders);
            })
            .fail(function (e) {
                console.error(e);
                d.reject(e);
            });

            return d.promise();
        };
        function loadFoldersForListValue(library, listValueId) {
            var d = $.Deferred();

            if (listValueId == '00000000-0000-0000-0000-000000000000') {
                d.resolve([]);
                return d.promise();
            }

            dataProvider
            .folders
            .getLibraryListValueFolders(library.libraryId, listValueId)
            .done(function (folders) {
                d.resolve(folders);
            })
            .fail(function (e) {
                e.stopPropagation = true;
                
                d.reject(e);

                console.error(e);
            });

            return d.promise();
        }
        function loadListValueForLibrary(library, filter) {
            var d = $.Deferred();
            var auto = filter == "auto";

            filter = auto ? "my" : filter;

            _loadListValueForLibrary(library, filter)
            .done(function (listData) {
                //var hasFollow = _.findWhere(listData.values, { following: true });

                if (auto && listData.values.length == 0) {
                    _loadListValueForLibrary(library, "all")
                    .done(function (listData) {
                        mapList(library.list, listData)
                        .done(function (data) {
                            library.list.isShowFollow("all");

                            d.resolve(data);
                        });
                    })
                    .fail(function (e) {
                        d.reject(e);
                        console.warn(e);
                    });
                } else {
                    mapList(library.list, listData)
                    .done(function (data) {
                        library.list.isShowFollow(filter);

                        d.resolve(data);
                    });
                }
            })
            .fail(function (e) {
                d.reject(e);

                console.error(e);
            });

            return d.promise();

            function mapList(list, listData) {
                var p = $.Deferred();
                var deferreds = [];

                var schema = _.map(listData.columns, function (column, index) {

                    if (column.type.toLowerCase() == "foreignkey") {
                        column.field = "col" + index;
                        deferreds.push(
                          dataProvider.lists.getListValues(column.relatedList.listId)
                            .done(function (relatedListLookupValues) {
                                column.relatedListLookupValues = relatedListLookupValues;
                            })
                        );
                    }

                    return column;
                });

                $.when.apply(this, deferreds).always(function () {
                    var values = _.map(listData.values, function (value) {
                        var valueMap = {
                            listValueId: value.listValueId,
                            following: value.following || false
                        };
                        _.each(value.columnValues, function (colValue, index) {
                            var columnDetails = schema[index];

                            if (columnDetails.type.toLowerCase() == "foreignkey") { // if this is the related list values field we need to go get the label description.
                                colValue = _.map(colValue, function (listValueId) {
                                    return {
                                        listValueId: listValueId,
                                        label: getListValueDescription(columnDetails.relatedListLookupValues, listValueId)
                                    };
                                });
                            }

                            valueMap[columnDetails.field] = colValue;
                        });

                        if (schema.length == 0) listData.labelFormat = "";
                        if (schema.length == 1) listData.labelFormat = "{0}";

                        valueMap.label = listData.labelFormat.replace(/{(\d+)}/g, function (match, group) {
                            return value.columnValues[group];
                        });

                        return valueMap;
                    });

                    list.schema(schema);
                    list.filters[listData.filter].values(values);
                    list.filters[listData.filter].isLoaded(true);
                    list.active.filter(listData.filter);
                    list.active.values(values);

                    p.resolve(list);
                });

                return p.promise();
            }
            function getListValueDescription(relatedListValues, listValueId) {
                var relatedListValue = _.find(relatedListValues, function (lookupValue) {
                    return lookupValue.listValueId == listValueId;
                });

                if (!relatedListValue)
                    return null;

                return relatedListValue.label;
            }
        }
        function _loadListValueForLibrary(library, filter) {
            var d = $.Deferred();

            dataProvider
            .lists
            .getLibraryList(library.list.listId, library.libraryId, filter)
            .done(function (listData) {
                d.resolve(listData);
            })
            .fail(function (e) {
                e.stopPropagation = true;

                d.reject(e);

                console.error(e);
            });

            return d.promise();
        }

        //function addDocumentsUpdateQ(documentId) {
        //    var itm = _.find(context.documentsUpdateQ, function (itm) {
        //        return itm.documentId == documentId;
        //    });

        //    if (itm)
        //        return;

        //    context.documentsUpdateQ.push({ documentId: documentId});
        //}
        //function removeDocumentsUpdateQ(documentId) {
        //    var itm = _.find(context.documentsUpdateQ, function (itm) {
        //        return itm.documentId == documentId;
        //    });

        //    context.documentsUpdateQ = _.without(context.documentsUpdateQ, itm);
        //}

        return context;

        function _findFolder(folders, folderId) {
            var found = _.find(folders, function (folder) {
                return folder.folderId == folderId;
            });

            if (!found) {
                for (var i = 0; i < folders.length; i++) {
                    var folder = folders[i];
                    if (folder.folders) {
                        found = _findFolder(folder.folders, folderId);
                        if (found)
                            break;
                    }
                }
            }

            return found;
        }
    });
